/* eslint-disable */
const namespace = 'ENTERPRISEINFO';
export const CHANGE_PAGE = `${namespace}CHANGE_PAGE`;
export const CHANGE_BTN = `${namespace}CHANGE_BTN`;
export const GET_BASIC_DATA = `${namespace}GET_BASIC_DATA`; //获取基本信息
export const GET_TABLE_DATA = `${namespace}GET_TABLE_DATA`; //获取表格信息
